<script setup>
import { ref } from 'vue';
import InboxReconnectionRequired from '../../components/InboxReconnectionRequired.vue';

import allegroClient from 'dashboard/api/channel/allegroClient';

import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

const isRequestingAuthorization = ref(false);

// The add-inbox flow reconnects too: the callback finds the channel by the seller id and calls
// reauthorized! on it, so the same seller account keeps this inbox.
async function requestAuthorization() {
  try {
    isRequestingAuthorization.value = true;
    const {
      data: { url },
    } = await allegroClient.generateAuthorization({
      authorization: { name: props.inbox.name },
    });

    window.location.href = url;
  } catch (error) {
    useAlert(t('INBOX_MGMT.ADD.ALLEGRO_CHANNEL.API.ERROR_MESSAGE'));
  } finally {
    isRequestingAuthorization.value = false;
  }
}
</script>

<template>
  <InboxReconnectionRequired
    class="mx-8 mt-5"
    :message="t('INBOX_MGMT.RECONNECT.ALLEGRO', { seller: inbox.seller_login })"
    @reauthorize="requestAuthorization"
  />
</template>
